export default __webpack_public_path__ + "static/media/title_th_sp.9672d783.png";